export const GET_PRODUCT_PAGE_PENDING = 'GET_PRODUCT_PAGE_PENDING';
export const GET_PRODUCT_PAGE_FULFILLED = 'GET_PRODUCT_PAGE_FULFILLED';
export const GET_PRODUCT_PAGE_REJECTED = 'GET_PRODUCT_PAGE_REJECTED';
export const GET_PRODUCT_PAGE_LOADING_MORE = 'GET_PRODUCT_PAGE_LOADING_MORE';
export const GET_PRODUCT_PAGE_LOADED_MORE = 'GET_PRODUCT_PAGE_LOADED_MORE';
export const PRODUCT_PAGE_TOGGLE_FILTER = 'PRODUCT_PAGE_TOGGLE_FILTER';
export const PRODUCT_PAGE_TOGGLE_ADVANCED_FILTER = 'PRODUCT_PAGE_TOGGLE_ADVANCED_FILTER';
export const PRODUCT_PAGE_SELECT_OUTLET = 'PRODUCT_PAGE_SELECT_OUTLET';
export const PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE = 'PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE';
export const PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE = 'PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE';
export const PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE = 'PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE';
export const PRODUCT_PAGE_SELECT_CLEAR_OBJECTIVE = 'PRODUCT_PAGE_SELECT_CLEAR_OBJECTIVE';
export const PRODUCT_PAGE_SELECT_CATEGORY = 'PRODUCT_PAGE_SELECT_CATEGORY';
export const PRODUCT_PAGE_CLEAR_FILTERS = 'PRODUCT_PAGE_CLEAR_FILTERS';
export const PRODUCT_PAGE_SELECT_NEW_PRODUCT = 'PRODUCT_PAGE_SELECT_NEW_PRODUCT';
export const PRODUCT_PAGE_SELECT_BRAND = 'PRODUCT_PAGE_SELECT_BRAND';
export const PRODUCT_PAGE_TURN_OFF_OBJECTIVE_FILTERS = 'PRODUCT_PAGE_TURN_OFF_OBJECTIVE_FILTERS';


export default function productPageReducer(state = {
  fetching: false,
  fetched: false,
  fetchingMore: false,
  fetchedMore: false,
  products: [],
  filter: {},
  filterBox: {
    showFilters: true,
    showAdvancedFilters: false,
    showObjectiveFilters: true,
    selectedOutlet: null,
    specialStockIt: null,
    specialPriceIt: null,
    specialSellIt: null,
    specialNew: null,
    categories: [],
    brands: []
  },
  showFocusRankWarning: false,
  showPriceMaximaWarning: false
}, action) {
  switch (action.type) {
    case GET_PRODUCT_PAGE_PENDING:
      return {
        ...state,
        fetching: true,
        fetched: false,
        products: [],
      };
    case GET_PRODUCT_PAGE_FULFILLED:
      return {
        ...state,
        fetching: false,
        fetched: true,
        products: action.payLoad.data,
        filter: action.payLoad.meta.filter,
        showFocusRankWarning: action.payLoad.meta['show-focus-rank-warning'],
        showPriceMaximaWarning: action.payLoad.meta['show-price-maxima-warning']
      };
    case GET_PRODUCT_PAGE_LOADING_MORE:
      return {
        ...state,
        fetchingMore: true,
        fetchedMore: false,
      };
    case GET_PRODUCT_PAGE_LOADED_MORE:
      return {
        ...state,
        fetchingMore: false,
        fetchedMore: true,
        products: state.products.concat(action.payLoad.data),
      };
    case PRODUCT_PAGE_TOGGLE_FILTER:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          showFilters: action.payLoad,
        }
      };
    case PRODUCT_PAGE_TOGGLE_ADVANCED_FILTER:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          showFilters: true,
          showAdvancedFilters: action.payLoad,
        }
      };
    case PRODUCT_PAGE_SELECT_OUTLET:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          selectedOutlet: action.payLoad,
        }
      };
    case PRODUCT_PAGE_SELECT_STOCK_IT_OBJECTIVE:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          specialStockIt: action.payLoad ? true : null,
        }
      };
    case PRODUCT_PAGE_SELECT_PRICE_IT_OBJECTIVE:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          specialPriceIt: action.payLoad ? true : null,
        }
      };
    case PRODUCT_PAGE_SELECT_SELL_IT_OBJECTIVE:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          specialSellIt: action.payLoad ? true : null,
        }
      };
    case PRODUCT_PAGE_SELECT_CLEAR_OBJECTIVE:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          specialStockIt: null,
          specialPriceIt: null,
          specialSellIt: null,
        }
      };
    case PRODUCT_PAGE_SELECT_CATEGORY:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          categories: action.payLoad
        }
      };
    case PRODUCT_PAGE_SELECT_BRAND:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          brands: action.payLoad
        }
      };
    case PRODUCT_PAGE_SELECT_NEW_PRODUCT:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          specialNew: state.filterBox.specialNew ? null : true,
        }
      };
    case PRODUCT_PAGE_CLEAR_FILTERS:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          selectedOutlet: null,
          specialStockIt: null,
          specialPriceIt: null,
          specialSellIt: null,
          specialNew: null,
          categories: [],
          brands: [],
        }
      };
    case PRODUCT_PAGE_TURN_OFF_OBJECTIVE_FILTERS:
      return {
        ...state,
        filterBox: {
          ...state.filterBox,
          showObjectiveFilters: false,
          showAdvancedFilters: true
        }
      };
    default:
      return {
        ...state
      };
  }
}



// WEBPACK FOOTER //
// ./src/reducers/productPageReducer.js